// extracted by mini-css-extract-plugin
export var container = "_c2-0";
export var segment = "_c2-2";
export var segmentActive = "_c2-3";
export var track = "_c2-1";